const gradeChapterJson = require("./data/dbGradeChapterBlock.json");
const activeGrades = gradeChapterJson.activeGrades;
const chapterContext = gradeChapterJson.chapterContext;
const gradesJson = gradeChapterJson.gradeChapters;
const underConstructionChapters = gradeChapterJson.underConstructionChapters;
const chapterNames = gradeChapterJson.chapterNames;
const RuntimeTrainerData = require("./RuntimeTrainerData");
const {FLAGS} = require("./GlobalFlags");

const _ = require("lodash");
const CHAPTER_NUMBERS = _.range(1, 13);

// Get all active grades, including grade 1
// if the accessUnfinishedGrades flag is set
const getAllActiveGrades = function() {
	return FLAGS.accessUnfinishedGrades && !global.TEST
		? gradeChapterJson.allGrades
		: activeGrades;
};

const isActiveGrade = function(gradeNumber, checkFlag = false) {
	if (checkFlag && FLAGS.accessUnfinishedGrades) return true;
	return _.includes(getAllActiveGrades(), gradeNumber);
};

const getActiveGrades = function() {
	return [].concat(getAllActiveGrades());
};

const getAllGrades = function() {
	return gradeChapterJson.allGrades;
};

const isValidChapterIndex = function(chapterIndex) {
	const index = parseInt(chapterIndex);
	return _.includes(
		CHAPTER_NUMBERS.map(n => n - 1),
		index
	);
};

const isValidChapterNumber = function(chapterNumber) {
	const num = parseInt(chapterNumber);
	return _.includes(CHAPTER_NUMBERS, num);
};

const getChaptersForGrade = function(gradeNumber, opts = {}) {
	let chapters = gradesJson[gradeNumber];

	if (opts.customScope && opts.customScope.length) {
		const scopeContext = getCustomScopeContext(opts.customScope);
		const chapterNumbers = scopeContext[gradeNumber];
		chapters = _.map(chapterNumbers, chapNum => {
			return toChapterID(gradeNumber, chapNum - 1);
		});
	}

	if (!opts.allowUnderConstruction) {
		chapters = _.difference(chapters, underConstructionChapters);
	}

	return chapters;
};

const getAllChaptersForGrade = function(gradeNumber) {
	return gradesJson[gradeNumber];
};

const getCustomScopeContext = function(chapterIDs) {
	const scopeContext = {};
	_.forEach(chapterIDs, chapterID => {
		const context = chapterContext[chapterID];
		if (scopeContext.hasOwnProperty(context[0])) {
			scopeContext[context[0]].push(context[1]);
		} else {
			scopeContext[context[0]] = [context[1]];
		}
	});
	return scopeContext;
};

// Last chapter in this grade for the student: full grade list, or purchase customScope when set.
const isLastChapterInLevelForScope = function(
	gradeNumber,
	chapterIndex,
	customScope = []
) {
	if (customScope.length) {
		const scopeContext = getCustomScopeContext(customScope);
		const chapterNumbers = scopeContext[gradeNumber];
		if (!chapterNumbers || !chapterNumbers.length) {
			return false;
		}
		return chapterIndex + 1 === _.max(chapterNumbers);
	}
	const chaptersInLevel = getAllChaptersForGrade(gradeNumber);
	return chapterIndex === chaptersInLevel.length - 1;
};

const getNextChapterID = function(
	gradeNumber,
	chapterNumber,
	customScope = []
) {
	if (chapterNumber === 12 && gradeNumber === _.max(activeGrades)) {
		// There is no next chapter in this case.
		return null;
	}

	if (!customScope.length) {
		if (chapterNumber === 12) {
			return gradesJson[gradeNumber + 1][0];
		} else {
			// This gets the next one as the JSON is keyed by index and
			// chapterNumber = chapterIndex + 1.
			return gradesJson[gradeNumber][chapterNumber];
		}
	} else {
		const scopeContext = getCustomScopeContext(customScope);
		const grades = _.keys(scopeContext).map(Number);

		// if it's the last chapter in the last grade (or later), there is no next chapter.
		const maxGrade = _.max(grades);
		if (
			(gradeNumber === maxGrade &&
				chapterNumber >= _.max(scopeContext[maxGrade])) ||
			gradeNumber > maxGrade
		) {
			return null;
		}

		// if there are no later chapters in this grade, go to the next grade
		if (
			!_.includes(grades, gradeNumber) ||
			chapterNumber >= _.max(scopeContext[gradeNumber])
		) {
			const gradeIndex = _.indexOf(grades, gradeNumber);
			const nextGrade = grades[gradeIndex + 1];
			const nextChapterNumber = scopeContext[nextGrade][0];
			return toChapterID(nextGrade, nextChapterNumber - 1);
		}

		// otherwise, go to the next chapter in the grade
		const chapterIndexInScope = _.indexOf(
			scopeContext[gradeNumber],
			chapterNumber
		);
		let nextChapterNumber = null;
		if (chapterIndexInScope !== -1) {
			nextChapterNumber = scopeContext[gradeNumber][chapterIndexInScope + 1];
		} else {
			// if the current chapter is not in the custom scope, find the next chapter that is
			nextChapterNumber = _.find(
				scopeContext[gradeNumber],
				n => n > chapterNumber
			);
		}
		return toChapterID(gradeNumber, nextChapterNumber - 1);
	}
};

// Last chapter in the student's scope with no further chapter (top active grade
// chapter 12, or end of customScope). Used for copy such as the culminating final test.
const isFinalAcademyChapterForScope = function(
	gradeNumber,
	chapterIndex,
	customScope = []
) {
	if (!isLastChapterInLevelForScope(gradeNumber, chapterIndex, customScope)) {
		return false;
	}
	return getNextChapterID(gradeNumber, chapterIndex + 1, customScope) == null;
};

// The locking algorithm uses this and requires that the chapters are returned
// in grade-chapter order, so don't break that.
const getAllActiveChapters = function() {
	let chapters = [];
	const grades = this.getActiveGrades();
	_.each(grades, g => {
		const gChapters = this.getChaptersForGrade(g, {
			allowUnderConstruction: FLAGS.accessUnfinishedChapters,
		});
		chapters = chapters.concat(gChapters);
	});

	return chapters;
};

const getAllChaptersNotUnderConstruction = function() {
	let chapters = [];
	const grades = this.getActiveGrades(true);
	_.each(grades, g => {
		chapters = chapters.concat(gradesJson[g]);
	});

	chapters = _.difference(chapters, underConstructionChapters);

	return chapters;
};

const getInactiveLibraryChapterIndexes = function() {
	return [];
};

const getFirstActiveLibraryChapterIndex = function() {
	return 0;
};

const getInactiveLibraryChapters = function() {
	return _.map(getInactiveLibraryChapterIndexes(), i => toChapterID(2, i));
};

const getActiveLibraryIndexPairing = function(gradeNumber, chapterIndex) {
	if (!isActiveGrade(gradeNumber)) {
		gradeNumber = 3;
	}
	if (
		(gradeNumber === 2 &&
			_.includes(getInactiveLibraryChapterIndexes(), chapterIndex)) ||
		getAllChaptersForGrade(gradeNumber).length <= chapterIndex ||
		chapterIndex < 0
	) {
		chapterIndex = getFirstActiveLibraryChapterIndex();
	}
	return {gradeNumber, chapterIndex};
};

const isActiveLibraryIndexPairing = function(gradeNumberIn, chapterIndexIn) {
	const {gradeNumber, chapterIndex} = getActiveLibraryIndexPairing(
		gradeNumberIn,
		chapterIndexIn
	);
	return gradeNumber === gradeNumberIn && chapterIndex === chapterIndexIn;
};

const getInactiveTheaterChapterIndexes = function() {
	return [];
};

const getFirstActiveTheaterChapterIndex = function() {
	return 0;
};

const getInactiveTheaterChapters = function() {
	return _.map(getInactiveTheaterChapterIndexes(), i => toChapterID(2, i));
};

const getActiveTheaterIndexPairing = function(gradeNumber, chapterIndex) {
	if (!isActiveGrade(gradeNumber)) {
		gradeNumber = 3;
	}
	if (
		(gradeNumber === 2 &&
			_.includes(getInactiveTheaterChapterIndexes(), chapterIndex)) ||
		getAllChaptersForGrade(gradeNumber).length <= chapterIndex ||
		chapterIndex < 0
	) {
		chapterIndex = getFirstActiveTheaterChapterIndex();
	}
	return {gradeNumber, chapterIndex};
};

const isActiveTheaterIndexPairing = function(gradeNumberIn, chapterIndexIn) {
	const {gradeNumber, chapterIndex} = getActiveTheaterIndexPairing(
		gradeNumberIn,
		chapterIndexIn
	);
	return gradeNumber === gradeNumberIn && chapterIndex === chapterIndexIn;
};

const isUnderConstruction = function(chapterID, checkFlag = false) {
	if (checkFlag && FLAGS.accessUnfinishedChapters) return false;
	return _.includes(underConstructionChapters, chapterID);
};

const getChapterName = function(grade, chapterNumber) {
	return chapterNames[grade][chapterNumber - 1];
};

const chapterIDToContext = function(chapterID) {
	const gradeChapterNum = chapterContext[chapterID];

	if (!gradeChapterNum) {
		return null;
	}

	const grade = gradeChapterNum[0];
	const index = gradeChapterNum[1] - 1;

	return {
		gradeNumber: grade,
		chapterIndex: index,
		name: chapterNames[grade][index],
	};
};

const chapterIDToGradeID = function(chapterID) {
	return _.get(chapterIDToContext(chapterID), "gradeNumber", null);
};

const toChapterID = function(gradeNumber, chapterIndex) {
	const grade = gradesJson[gradeNumber];
	return grade && isValidChapterIndex(chapterIndex)
		? grade[chapterIndex]
		: null;
};

const getAdjacentChaptersFromChapterID = (chapterID, customScope = []) => {
	if (!chapterID) {
		return {};
	}

	const {gradeNumber, chapterIndex} = chapterIDToContext(chapterID);
	return getAdjacentChapters(gradeNumber, chapterIndex, customScope);
};

const getAdjacentChapters = function(
	gradeNumber,
	chapterIndex,
	customScope = []
) {
	const previousInfo = getAdjacentChapter(
		gradeNumber,
		chapterIndex,
		true,
		customScope
	);
	const nextInfo = getAdjacentChapter(
		gradeNumber,
		chapterIndex,
		false,
		customScope
	);
	const getActiveInfo = info => {
		return !info ||
			isUnderConstruction(info.id, true) ||
			!isActiveGrade(info.gradeNumber, true)
			? null
			: info;
	};
	return {
		previous: getActiveInfo(previousInfo),
		next: getActiveInfo(nextInfo),
	};
};

// Takes in gradeNumber, chapterIndex, customScope (an array of chapters that exists if the
// student is part of a purchase with a custom scope; defaults to empty), and a boolean
// forPrev that's true if it should get the previous chapter and false if it should get the
// next chapter
// Returns an object with gradeNumber, chapterIndex, id if that adjacent
// chapter exists and null otherwise.
const getAdjacentChapter = function(
	gradeNumber,
	chapterIndex,
	forPrev,
	customScope = []
) {
	if (forPrev) {
		if (customScope.length) {
			const scopeContext = getCustomScopeContext(customScope);
			const gradesInScope = _.keys(scopeContext).map(Number);
			const maxGrade = _.max(gradesInScope);
			const gradeIndexInScope = _.indexOf(gradesInScope, gradeNumber);

			if (chapterIndex + 1 <= _.min(scopeContext[gradeNumber])) {
				// no previous chapters in this grade are included in the custom scope; looking for previous chapter
				if (gradeIndexInScope > 0) {
					// if there are previous grades in the custom scope, go to the last chapter in the previous grade
					gradeNumber = gradesInScope[gradeIndexInScope - 1];
					chapterIndex = _.max(scopeContext[gradeNumber]) - 1;
				} else {
					// treat earliest grade in custom scope the same way we normally treat BA1
					gradeNumber = 0;
				}
			} else if (gradeNumber > maxGrade) {
				// current grade is past the last grade that's in the custom scope; looking for previous chapter
				gradeNumber = maxGrade;
				chapterIndex = _.max(scopeContext[gradeNumber]) - 1;
			} else {
				const previousChapterNumber = _.findLast(
					scopeContext[gradeNumber],
					n => n < chapterIndex + 1
				);
				chapterIndex = previousChapterNumber - 1;
			}
		} else {
			// no custom scope; default case
			if (chapterIndex === 0) {
				// first chapter in grade, looking for previous chapter
				gradeNumber -= 1;
				chapterIndex = 11;
			} else {
				chapterIndex -= 1;
			}
		}
	} else {
		if (customScope.length) {
			const scopeContext = getCustomScopeContext(customScope);
			const gradesInScope = _.keys(scopeContext).map(Number);
			const minGrade = _.min(gradesInScope);
			const gradeIndexInScope = _.indexOf(gradesInScope, gradeNumber);

			if (chapterIndex + 1 >= _.max(scopeContext[gradeNumber])) {
				// no later chapters in this grade are included in the custom scope; looking for next chapter
				if (gradeIndexInScope < gradesInScope.length - 1) {
					// if there are later grades in the custom scope, go to the first chapter in the next grade
					gradeNumber = gradesInScope[gradeIndexInScope + 1];
					chapterIndex = _.min(scopeContext[gradeNumber]) - 1;
				} else {
					// treat latest grade in custom scope the same way we normally treat BA5
					gradeNumber = 6;
				}
			} else if (gradeNumber < minGrade) {
				// current grade is before the earliest grade that's in the custom scope; looking for next chapter
				gradeNumber = minGrade;
				chapterIndex = _.min(scopeContext[gradeNumber]) - 1;
			} else {
				const nextChapterNumber = _.find(
					scopeContext[gradeNumber],
					n => n > chapterIndex + 1
				);
				chapterIndex = nextChapterNumber - 1;
			}
		} else {
			// no custom scope; default case
			if (chapterIndex === 11) {
				// last chapter in grade, looking for next chapter
				gradeNumber += 1;
				chapterIndex = 0;
			} else {
				chapterIndex += 1;
			}
		}
	}

	const id = toChapterID(gradeNumber, chapterIndex);
	// Check if grade is active and chapterID is value, and if not then return null
	return isActiveGrade(gradeNumber) && id
		? {gradeNumber, chapterIndex, id}
		: null;
};

// Given a chapter ID, returns an array of chapter IDs that come before this chapter,
// plus the given chapterID itself.
// Used to determine which lab types to unlock when starring a block in a chapter.
const getAllChaptersUpTo = function(chapterID) {
	let retChapterIDs = [];
	_.each(gradeChapterJson.allGrades, gradeNumber => {
		const graderChapterIDs = gradeChapterJson.gradeChapters[gradeNumber];
		const chapterIndex = _.indexOf(graderChapterIDs, chapterID);
		if (chapterIndex < 0) {
			retChapterIDs = _.concat(retChapterIDs, graderChapterIDs);
		} else {
			retChapterIDs = _.concat(
				retChapterIDs,
				_.slice(graderChapterIDs, 0, chapterIndex + 1)
			);
			return false;
		}
	});
	return retChapterIDs;
};

const toBlockID = function(chapterID, blockIndex) {
	return _.get(
		RuntimeTrainerData.getChapterBlocks(),
		[chapterID, blockIndex],
		null
	);
};

const toBlockIndex = function(chapterID, blockID) {
	const blockIDs = _.get(RuntimeTrainerData.getChapterBlocks(), chapterID, []);
	const blockIndex = _.indexOf(blockIDs, blockID);
	return blockIndex < 0 ? null : blockIndex;
};

const getNumBlocksInChapterID = function(chapterID, grade) {
	// Defaulting to 15 so that even if we're wrong, the values won't look incorrect
	// to the user.
	const defaults = {2: 15, 3: 15, 4: 18, 5: 20};
	return (
		_.get(RuntimeTrainerData.getChapterBlocks(), chapterID, []).length ||
		defaults[grade] ||
		15
	);
};

const getNumBlocksInChapter = function(grade, chapterIndex) {
	const chapterID = toChapterID(grade, chapterIndex);
	return getNumBlocksInChapterID(chapterID, grade);
};

module.exports = {
	CHAPTER_NUMBERS,
	isActiveGrade,
	getActiveGrades,
	getAllGrades,
	isValidChapterIndex,
	isValidChapterNumber,
	getChaptersForGrade,
	getAllChaptersForGrade,
	getCustomScopeContext,
	isLastChapterInLevelForScope,
	isFinalAcademyChapterForScope,
	getNextChapterID,
	getAllActiveChapters,
	getAllChaptersNotUnderConstruction,
	isUnderConstruction,
	getFirstActiveLibraryChapterIndex,
	getInactiveLibraryChapterIndexes,
	getInactiveLibraryChapters,
	isActiveLibraryIndexPairing,
	getActiveLibraryIndexPairing,
	getFirstActiveTheaterChapterIndex,
	getInactiveTheaterChapterIndexes,
	getInactiveTheaterChapters,
	isActiveTheaterIndexPairing,
	getActiveTheaterIndexPairing,
	getChapterName,
	chapterIDToContext,
	chapterIDToGradeID,
	toChapterID,
	getAdjacentChaptersFromChapterID,
	getAdjacentChapters,
	getAdjacentChapter,
	getAllChaptersUpTo,
	toBlockID,
	toBlockIndex,
	getNumBlocksInChapterID,
	getNumBlocksInChapter,
};
